import Vue from 'vue';
import throttle from 'lodash/throttle';
import { EventBus } from '../../mixins/event';

export function isElementInViewport(element) {
  const isInViewPort =
    element.offsetTop < window.pageYOffset + window.innerHeight &&
    element.offsetLeft < window.pageXOffset + window.innerWidth &&
    element.offsetTop + element.offsetHeight > window.pageYOffset &&
    element.offsetLeft + element.offsetWidth > window.pageXOffset;
  return isInViewPort;
}

export const load = {
  bind: (el, binding) => {
    const maybeInjectScript = throttle(() => {
      const rect = el.getBoundingClientRect();
      if (isElementInViewport(el)) {
        const mobileTabElement = document.getElementById('mobile-tab');
        const desktopTabElement = document.getElementById('desktop-tab');
        const mobileSticky = 'mobile-sticky';
        const desktopSticky = 'desktop-sticky';
        if (binding.value && binding.value.dropdown) {
          rect.top < 300 && mobileTabElement && mobileTabElement.classList.add(mobileSticky);
          rect.top < 300 && desktopTabElement && desktopTabElement.classList.add(desktopSticky);
        } else if (binding.value && binding.value.remove) {
          mobileTabElement && mobileTabElement.classList.remove(mobileSticky);
          desktopTabElement &&
            rect.top < 0 &&
            desktopTabElement.classList.contains(desktopSticky) &&
            desktopTabElement.classList.remove(desktopSticky);
        } else if (binding.value && binding.value === true) {
          rect.top < 130 && EventBus.$emit('emittedEvent', el.getAttribute('id'));
        } else {
          window.removeEventListener('scroll', maybeInjectScript);
        }
      }
    }, 50);

    window.addEventListener('scroll', maybeInjectScript);

    // call immediately to check if currently in viewport
    Vue.nextTick(maybeInjectScript);
  },
};
